import { QuestionnaireSectionProps } from '@/types/questionnaire';
import { SectionForm } from './SectionForm';
import { useSmartSectionUpdate } from '../hooks/useSmartSectionUpdate';

export function EditSectionModal({
  section,
  allSections,
  onClose,
}: {
  section: QuestionnaireSectionProps;
  allSections: Array<{ id: number; section_order: number; [key: string]: any }>;
  onClose: () => void;
}) {
  const { updateSectionMutation, handleSubmit } = useSmartSectionUpdate({
    section,
    allSections,
    onClose,
  });

  return (
    <SectionForm
      onSubmit={handleSubmit}
      onCancel={onClose}
      isSubmitting={updateSectionMutation.isPending}
      initialData={{
        section_name: section.section_name,
        description: section.description,
        section_order: section.section_order,
      }}
    />
  );
}
